import React from "react";
import "./MobileSearchOverlay.css";
import { ITerminalDto } from "../../../models/TerminalDto";
import { SearchHeaderMobile } from "../../header/search-header-mobile/SearchHeaderMobile";
import StateBadge from "../../badge/StateBadge";
import Collapsible from "../../collapsible/Collapsible";
import $ from "jquery";
import * as _ from "lodash";
import { IUserDto } from "../../../models/UserDto";
import { SearchType } from "../SearchType";
import { Route } from "react-router-dom";
import { UserInfoButton } from "../../buttons/user-info-button/UserInfoButton";
import { TidStatusDto } from "../../../models/TidStatusDto";
import CheckIcon from "../../../resources/wrappers/CheckIcon";
import { Button } from "@material-ui/core";
import { Pagination } from "../../../utils/Pagination";
import { TerminalOperationType } from "../../../utils/TerminalOperationTypeEnum";
import { MposLoader } from "../../loader/MposLoader";
import { sessionStorageInstance } from "../../../services/storage/Storage";
import { AddUserRequest } from "../../../models/AddUserRequest";
import { MposWebPortalApi } from "../../../services/api/MposWebPortalApi";
import { UserType } from "../../../utils/UserTypeEnum";
import * as querystring from "querystring";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import { TerminalUpdateOrRemoveRequest } from "../../../models/TerminalUpdateOrRemove";
import { Mapper } from "../../../utils/Mapper";

export class MobileSearchOverlay extends React.Component<any, any> {
  terminalList: Array<ITerminalDto> | null = null;
  userList: Array<IUserDto> | null = null;
  footerElement: any;
  pagination: Pagination<ITerminalDto> | undefined;
  data: object;
  private mobilePosId: string | null = null;
  constructor(props: any) {
    super(props);
    if (SearchType.TERMINAL_INFO_WITH_USERS === this.props.location.state.type) {
      this.terminalList = this.props.location.state.values;
      this.pagination = new Pagination(5);
      this.pagination.setInputData(this.sortArrayForTerminalId(this.terminalList!));
    }

    if (SearchType.USER_INFO === this.props.location.state.type) {
      this.userList = this.props.location.state.values;
    }

    if (SearchType.TERMINAL_LIST === this.props.location.state.type) {
      this.terminalList = this.props.location.state.values;
      this.pagination = new Pagination(5);
      this.pagination.setInputData(this.sortArrayForTerminalId(this.terminalList!));
    }

    this.state = {
      filteredTerminals: [],
      filteredUsers: [],
      selectedElement: null,
      buttonDisabled: true,
      terminalToShow: null,
      showLoader: false,
      showResultDialog: false,
      addUserResult: false,
    };

    this.data = this.props.location.state.data;
    this.mobilePosId = this.props.location.state.mobilePosId;
    console.log("MobileSearchOverlay -> Data are: " + JSON.stringify(this.data));
  }

  private mobileSearchValueProvided(value: string) {
    if (SearchType.TERMINAL_INFO_WITH_USERS === this.props.location.state.type) {
      this.pagination!.resetPaginator();
      let filteredInput = this.filterTerminalsElements(value);
      this.setState({ filteredTerminals: filteredInput });
      this.pagination!.setInputData(filteredInput);
      this.getTerminalsToShow();
    } else if (SearchType.USER_INFO === this.props.location.state.type) {
      this.setState({ filteredUsers: this.filterUserElements(value) });
    } else if (SearchType.TERMINAL_LIST === this.props.location.state.type) {
      this.pagination!.resetPaginator();
      let filteredInput = this.filterTerminalsElements(value);
      this.setState({ filteredTerminals: filteredInput });
      this.pagination!.setInputData(filteredInput);
      this.getTerminalsToShow();
    }
  }

  private filterTerminalsElements(filter: string): Array<ITerminalDto> {
    let elements = Array.from(this.terminalList!);
    if (filter.length >= 3) {
      if (SearchType.TERMINAL_LIST === this.props.location.state.type) {
        // @ts-ignore
        GoogleTagManagerService.getInstance().pushInteractionEvent("RicercaOverlay", this.data.headerTitle + " terminale id", "search", "ricerca id terminale");
      } else if (SearchType.TERMINAL_INFO_WITH_USERS === this.props.location.state.type) {
        GoogleTagManagerService.getInstance().pushInteractionEvent("RicercaOverlay", "i tuoi terminali", "search", "ricerca id terminale");
      }
      return elements.filter((obj) => {
        return obj.terminalId.includes(filter);
      });
    } else {
      return [];
    }
  }

  private getTerminalsToShow() {
    this.setState({ terminalToShow: this.pagination!.getNext() });
  }

  private filterUserElements(filter: string): Array<IUserDto> {
    let elements = Array.from(this.userList!);
    if (filter.length >= 3) {
      GoogleTagManagerService.getInstance().pushInteractionEvent("RicercaOverlay", "le tue utenze", "search", "ricerca per utenza");
      return elements.filter((obj) => {
        return obj.username.toLowerCase().includes(filter.toLowerCase());
      });
    } else {
      return [];
    }
  }

  private selectElement(terminal: ITerminalDto) {
    console.log("[MobileSearchOverlay][selectElement] Selected element: " + JSON.stringify(terminal));
    this.setState({ selectedElement: terminal });
    this.setState({ buttonDisabled: false });
  }

  private sortArrayForTerminalId(array: ITerminalDto[] | undefined): ITerminalDto[] {
    if (array !== undefined) {
      return array.sort((a, b) => {
        return b.terminalId > a.terminalId ? -1 : 1;
      });
    } else {
      return [];
    }
  }

  private startAddUserProcedure() {
    console.log("[MobileSearchOverlay][startAddUserProcedure] Add user!");
    // Retrieve contract code of superuser
    if (sessionStorageInstance.getData("user") !== null) {
      let user = JSON.parse(sessionStorageInstance.getData("user")!);
      // @ts-ignore
      let contractCode = user.contractCode;
      let addUserRequest = new AddUserRequest(
        contractCode,
        // @ts-ignore
        this.data.description,
        // @ts-ignore
        this.data.email,
        null,
        null,
        this.state.selectedElement?.terminalId && this.state.selectedElement?.terminalType === "MPOS"
          ? this.state.selectedElement?.terminalId
          : this.mobilePosId,
        this.state.selectedElement?.terminalId && this.state.selectedElement?.terminalType === "SOFTPOS" ? this.state.selectedElement?.terminalId : null
      );
      this.setState({ showLoader: true });
      MposWebPortalApi.getInstance()
        .addUser(addUserRequest)
        .subscribe(
          (result) => {
            console.log("[MobileSearchOverlay] Response: " + result);
            this.setState({ showLoader: false });
            this.setState({ showResultDialog: true });
            this.setState({ addUserResult: true });
            this.showAddUserResult();
          },
          (error) => {
            console.log("[MobileSearchOverlay] Response: " + JSON.stringify(error));
            this.setState({ showLoader: false });
            this.setState({ showResultDialog: true });
            this.setState({ addUserResult: false });
            this.showAddUserResult();
          }
        );
    }
  }

  private changeTidForUser(history: any) {
    console.log("[MobileSearchOverlay][changeTidForUser] Change TID user!");
    if (sessionStorageInstance.getData("user") !== null) {
      let user = JSON.parse(sessionStorageInstance.getData("user")!);
      let request = undefined;
      let queryParams: any;
      let username: string;
      // @ts-ignore
      if (this.data.tidOperation === TerminalOperationType.CHANGE_TERMINAL_ID_TO_ADMIN_USER) {
        request = new TerminalUpdateOrRemoveRequest(this.state.selectedElement?.terminalId!, user.username);
        username = user.username;
        queryParams = { userType: UserType.ADMIN, description: user.description !== undefined ? encodeURIComponent(user.description) : "" };
      } else {
        // @ts-ignore
        if (this.data.user !== null) {
          // @ts-ignore
          user = this.data.user;
          request = new TerminalUpdateOrRemoveRequest(this.state.selectedElement?.terminalId!, user?.username!);
          username = user?.username!;
          queryParams = { userType: UserType.STAFF, description: user?.description! !== undefined ? encodeURIComponent(user?.description!) : "" };
        } else {
          // This request are executed with error, this behaviour is desired
          request = new TerminalUpdateOrRemoveRequest(this.state.selectedElement?.terminalId!, "");
          queryParams = { userType: UserType.STAFF, description: user?.description! !== undefined ? encodeURIComponent(user?.description!) : "" };
        }
        console.log("[MobileSearchOverlay] Request: " + JSON.stringify(request));
        this.setState({ showLoader: true });
        MposWebPortalApi.getInstance()
          .updateTerminalToUser(request)
          .subscribe(
            (result) => {
              console.log("[MobileSearchOverlay] Response: " + result);
              this.setState({ showLoader: false });
              // @ts-ignore
              if (this.data.tidOperation === TerminalOperationType.CHANGE_TERMINAL_ID_TO_ADMIN_USER) {
                //@ts-ignore
                queryParams.terminalStatus = TidStatusDto.ACTIVE;
                console.log("[MobileSearchOverlay] ADMIN USER tid changed");
                window.history.pushState(null, "", "/");
                let link = `/users/${username}?${querystring.stringify(queryParams)}`;
                history.push("/users", { data: { redirectTo: link } });
                // @ts-ignore
              } else if (this.data.tidOperation === TerminalOperationType.CHANGE_TERMINAL_ID_TO_STAFF_USER) {
                //@ts-ignore
                queryParams.terminalStatus = TidStatusDto.ACTIVE;
                console.log("[MobileSearchOverlay] STAFF USER tid changed");
                window.history.pushState(null, "", "/");
                let link = `/users/${username}?${querystring.stringify(queryParams)}`;
                history.push("/users", { data: { redirectTo: link } });
              }
            },
            (error) => {
              console.log("[MobileSearchOverlay] Error: " + JSON.stringify(error));
              this.setState({ showLoader: false });
              history.push("/result", {
                isSuccess: false,
                button: "TORNA ALLE UTENZE",
                data: { from: "MobileSearchOverlay", operation: "changeTidForUser" },
              });
            }
          );
      }
    }
  }

  componentWillMount() {
    console.log("[MobileSearchOverlay] componentWillMount!");
    if (SearchType.TERMINAL_LIST === this.props.location.state.type || SearchType.TERMINAL_INFO_WITH_USERS === this.props.location.state.type) {
      this.getTerminalsToShow();
    }
  }

  componentDidMount() {
    this.footerElement = $("#mobile-footer-body").remove();
  }

  componentWillUnmount() {
    $("#app").append(this.footerElement);
  }

  private goToUserInfoDetails(history: any, user: IUserDto, userType: UserType) {
    console.log("[MobileSearchOverlay] Go to user details for " + user.username);
    this.props.location.state = null;
    let queryParams = {
      userType: userType,
      description: user.description !== null ? encodeURIComponent(user.description) : "",
    };
    let link = `/users/${user.username}?${querystring.stringify(queryParams)}`;
    history.push(link);
  }

  render() {
    return (
      <div id={"mobile-search-overlay-page"}>
        <div id={"mobile-search-overlay-content"}>
          <SearchHeaderMobile
            placeholder={this.props.location.state.placeholder}
            onValueChanged={(value: string) => {
              this.mobileSearchValueProvided(value);
            }}
            inputType={SearchType.USER_INFO === this.props.location.state.type ? "text" : "number"}
          />
          <div className={"mobile-search-overlay-separator"} />
          {[
            SearchType.TERMINAL_INFO_WITH_USERS === this.props.location.state.type &&
            (this.state.filteredTerminals.length === 1 ? (
              <p className={"mobile-search-overlay-result-counter"}>
                <b>1</b> risultato trovato
              </p>
            ) : (
              <p className={"mobile-search-overlay-result-counter"}>
                <b>{this.state.filteredTerminals.length}</b> risultati trovati
              </p>
            )),
            SearchType.USER_INFO === this.props.location.state.type &&
            (this.state.filteredUsers.length === 1 ? (
              <p className={"mobile-search-overlay-result-counter"}>
                <b>1</b> risultato trovato
              </p>
            ) : (
              <p className={"mobile-search-overlay-result-counter"}>
                <b>{this.state.filteredUsers.length}</b> risultati trovati
              </p>
            )),
            SearchType.TERMINAL_LIST === this.props.location.state.type &&
            (this.state.filteredTerminals.length === 1 ? (
              <p className={"mobile-search-overlay-result-counter"}>
                <b>1</b> risultato trovato
              </p>
            ) : (
              <p className={"mobile-search-overlay-result-counter"}>
                <b>{this.state.filteredTerminals.length}</b> risultati trovati
              </p>
            )),
          ]}
          {[
            SearchType.TERMINAL_INFO_WITH_USERS === this.props.location.state.type && (
              <div className={"mobile-search-overlay-table-container"}>
                {this.state.terminalToShow.map((element: ITerminalDto) => {
                  let index = _.findIndex(this.state.filteredTerminals, (val: ITerminalDto) => {
                    return val.terminalId === element.terminalId;
                  });
                  return (
                    <div key={element.terminalId} className={"terminal-table-row"}>
                      <div className={index === 0 ? "terminal-table-row-content-first-row" : "terminal-table-row-content"}>
                        <p className={"terminal-tid-label"}>{element.terminalId}</p>
                        <div className={"terminal-badge-container"}>
                          <StateBadge
                            userState={
                              element.users === undefined || (element.users !== undefined && element.users?.length === 0)
                                ? TidStatusDto.NOT_ASSIGNED
                                : element.tidStatus
                            }
                          />
                        </div>
                        <Collapsible
                          header={
                            element.users?.length === 0
                              ? "Non assegnato"
                              : element.users?.length === 1
                                ? "Assegnato a 1 utenza"
                                : "Assegnato a " + element.users?.length + " utenze"
                          }
                          elements={element.users}
                        />
                      </div>
                    </div>
                  );
                })}
                {this.pagination!.hasMoreElements() && (
                  <Button
                    id={"mobile-search-choose-terminal-show-more-button"}
                    className={"mobile-search-choose-terminal-show-more-button-margin"}
                    onClick={() => {
                      this.getTerminalsToShow();
                    }}
                    disableRipple>
                    {"Mostra di più".toUpperCase()}
                  </Button>
                )}
              </div>
            ),
            SearchType.USER_INFO === this.props.location.state.type && (
              <div className={"mobile-search-overlay-table-container"}>
                {this.state.filteredUsers.map((element: IUserDto) => {
                  let index = _.findIndex(this.state.filteredUsers, (val: IUserDto) => {
                    return val.username.toLowerCase() === element.username.toLowerCase();
                  });
                  return (
                    <div className={index === 0 ? "user-table-row user-overlay-new-margin-top" : "user-table-row"}>
                      <div key={element.username} className={"user-table-column"}>
                        <Route
                          render={({ history }) => {
                            return (
                              <UserInfoButton
                                user={element.username}
                                role={element.description != null ? element.description : Mapper.mapItalianParamToUserType(element.userType) === UserType.DEVELOPER ? 'Sviluppatore' : "--"}
                                onClick={() => {
                                  this.goToUserInfoDetails(history, element, Mapper.mapItalianParamToUserType(element.userType))
                                }}
                              />
                            );
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            ),
            SearchType.TERMINAL_LIST === this.props.location.state.type && (
              <div className={"mobile-search-choose-terminal-terminal-table"}>
                {this.state.terminalToShow?.map((value: ITerminalDto, index: number) => {
                  return (
                    <div
                      key={index}
                      id={value.terminalId}
                      className={
                        value.tidStatus === TidStatusDto.SUSPENDED
                          ? "choose-terminal-terminal-table-element-disabled"
                          : this.state.selectedElement !== null && this.state.selectedElement.terminalId === value.terminalId
                            ? "choose-terminal-terminal-table-element-selected"
                            : "choose-terminal-terminal-table-element"
                      }
                      onClick={
                        value.tidStatus === TidStatusDto.SUSPENDED
                          ? undefined
                          : () => {
                            this.selectElement(value);
                          }
                      }>
                      <div className={"choose-terminal-table-element-content"}>
                        <div className={"choose-terminal-table-element-content-one"}>
                          <p className={value.tidStatus === TidStatusDto.SUSPENDED ? "choose-terminal-terminal-id-suspended" : "choose-terminal-terminal-id"}>
                            {value.terminalId}
                          </p>
                          <StateBadge
                            userState={
                              value.users === undefined || (value.users !== undefined && value.users?.length === 0)
                                ? TidStatusDto.NOT_ASSIGNED
                                : value.tidStatus
                            }
                          />
                        </div>
                        <div className={"choose-terminal-table-element-content-two"}>
                          {this.state.selectedElement === null || this.state.selectedElement.terminalId !== value.terminalId ? null : (
                            <CheckIcon width={"21px"} heigth={"16px"} color={"#000000"} />
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
                {this.pagination!.hasMoreElements() && (
                  <Button
                    id={"mobile-search-choose-terminal-show-more-button"}
                    onClick={() => {
                      this.getTerminalsToShow();
                    }}
                    disableRipple>
                    {"Mostra di più".toUpperCase()}
                  </Button>
                )}
                <Route
                  render={({ history }) => {
                    return (
                      <Button
                        id={"mobile-search-choose-terminal-confirm-button"}
                        type={"button"}
                        disabled={this.state.buttonDisabled}
                        onClick={() => {
                          // @ts-ignore
                          if (this.data.tidOperation === TerminalOperationType.ADD_TERMINAL_ID_TO_USER) {
                            console.log("[MobileSearchOverlay] Add User");
                            this.startAddUserProcedure();
                          }
                          // @ts-ignore
                          else if (this.data.tidOperation === TerminalOperationType.CHOOSE_AGAIN) {
                            history.push("/chooseTerminal", {
                              // @ts-ignore
                              email: this.data.email,
                              headerTitle: "Crea nuova utenza",
                              alternativeTitle: "Ora assegna un ID Terminale SoftPOS",
                              tidOperation: TerminalOperationType.ADD_TERMINAL_ID_TO_USER,
                              terminalType: "SOFTPOS",
                              mobilePosId: this.state.selectedElement?.terminalId ?? null,
                              // @ts-ignore
                              description: this.data.description,
                            });
                          } else {
                            console.log("[MobileSearchOverlay] Change tid for User!");
                            this.changeTidForUser(history);
                          }
                        }}>
                        {
                          // @ts-ignore
                          this.data.tidOperation === TerminalOperationType.CHOOSE_AGAIN ? "AVANTI" : "CONFERMA"
                        }
                      </Button>
                    );
                  }}
                />
              </div>
            ),
          ]}
        </div>
        {
          // @ts-ignore
          <MposLoader show={this.state.showLoader} />
        }
      </div>
    );
  }

  private showAddUserResult() {
    //@ts-ignore
    let email = this.data.email;
    this.props.history.push("/result", {
      isSuccess: this.state.addUserResult,
      title: "Hai creato un nuovo membro del tuo staff!",
      button: "VEDI ELENCO UTENZE",
      data: {
        from: "MobileSearchOverlay",
        operation: "addUser",
        email: email,
        result: this.state.addUserResult,
      },
    });
  }
}
